// Medición del quiz. Módulo aparte a propósito: quiz.js emite eventos del DOM
// y no sabe nada de analítica; este archivo los traduce a dataLayer. Si mañana
// cambia la herramienta, se cambia este archivo y el motor no se toca.
//
// POR QUÉ SOLO dataLayer, y no fbq ni gtag directos:
// la tienda ya carga GTM (GTM-NWPC2QT4) y Shopify Web Pixels. Disparar píxeles
// desde aquí duplicaría eventos que GTM ya enruta y rompería el consentimiento
// que GTM administra. AGENTS.md lo pide explícitamente.
//
// CONVENCIÓN: los eventos propios de la tienda usan el prefijo afh_
// (afh_newsletter_signup, afh_contact_form_submit...). El quiz lo respeta:
// afh_quiz_view, afh_quiz_answer, etc. Catálogo completo y cómo consultarlo:
// docs/quiz/MEDICION.md.
//
// SIN DUPLICAR EL COMERCIO ESTÁNDAR: el carrito y la compra ya los miden
// Shopify Web Pixels (product_added_to_cart, checkout_started,
// checkout_completed). Por eso solo afh_quiz_result_view lleva el objeto
// «ecommerce» (para públicos con producto); el resto manda los productos en
// quiz_items, que ninguna etiqueta de ecommerce lee por defecto.
//
// SIN DATOS PERSONALES: el correo y el nombre NUNCA se empujan al dataLayer.

const PREFIJO = 'afh_';

const dl = () => {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

function empujar(nombre, datos) {
  dl().push({ event: PREFIJO + nombre, ...datos });
}

// Mismo id que usa el remarketing dinámico de la tienda.
const itemId = (handle) => `shopify_${handle}`;
const pesos = (centavos) => (centavos || 0) / 100;

function item(producto, indice = 0, cantidad = 1) {
  if (!producto) return null;
  return {
    index: indice,
    item_id: itemId(producto.handle),
    item_name: producto.titulo,
    price: pesos(producto.precio),
    quantity: cantidad,
  };
}

// Cada evento del DOM → nombre en dataLayer y campos. quiz_id va siempre.
const EVENTOS = {
  open: ['quiz_open', (d) => ({ quiz_origen: d.desde })],
  view: ['quiz_view', (d) => ({ quiz_origen: d.origen, quiz_desde: d.desde ? `shopify_${d.desde}` : undefined })],
  start: ['quiz_start', (d) => ({ quiz_retomado: Boolean(d.retomado) })],
  step: [
    'quiz_answer',
    (d) => ({ question_id: d.pregunta, answer_id: d.opcion, step_number: d.paso, step_total: d.total }),
  ],
  why_open: ['quiz_why_open', (d) => ({ question_id: d.pregunta })],
  // Beneficio desbloqueado por avanzar (hoy ningún quiz tiene: vuelve con la guía).
  gift: ['quiz_gift', (d) => ({ quiz_regalo: d.regalo })],
  complete: ['quiz_complete', (d) => ({ quiz_respondidas: d.respondidas })],
  email_view: ['quiz_email_view', (d) => ({ quiz_email_obligatorio: d.obligatoria })],
  // El lead SIN datos personales: solo que ocurrió.
  lead: ['quiz_email_submit', () => ({ quiz_consentimiento: true })],
  email_skip: ['quiz_email_skip', () => ({})],
  analysis_view: ['quiz_analysis_view', () => ({})],
  result: [
    'quiz_result_view',
    (d) => ({
      product_id: itemId(d.handle),
      result_key: d.handle,
      recommendation_reason: d.motivo,
      quiz_addons: (d.complementos || []).map(itemId).join(','),
      quiz_formato_no_disponible: d.formato_no_disponible,
      ecommerce: d.producto
        ? { currency: d.moneda || 'COP', value: pesos(d.producto.precio), items: [item(d.producto)] }
        : undefined,
    }),
  ],
  no_result: ['quiz_no_result', (d) => ({ quiz_motivo: d.motivo })],
  purchase_type: ['quiz_purchase_type_select', (d) => ({ product_id: itemId(d.handle), purchase_type: d.tipo })],
  addon_click: [
    'quiz_addon_click',
    (d) => ({ product_id: itemId(d.handle), result_key: d.resultado, quiz_accion: d.accion }),
  ],
  primary_click: [
    'quiz_primary_product_click',
    (d) => ({
      product_id: itemId(d.handle),
      quiz_accion: d.accion,
      purchase_type: d.tipo,
      quiz_cantidad: d.cantidad,
      quiz_valor: pesos(d.valor),
    }),
  ],
  add_to_cart: [
    'quiz_add_to_cart',
    (d) => ({
      product_id: itemId(d.handle),
      purchase_type: 'one_time',
      quiz_valor: pesos(d.valor),
      quiz_con_addons: (d.complementos || []).length > 0,
      quiz_items: (d.items || []).map((x, i) => ({ ...item(x, i, x.cantidad), item_category: x.rol })),
    }),
  ],
  // La suscripción se cobra en Treli, fuera de Shopify: este es el último
  // punto que el navegador ve. La compra efectiva se concilia con Treli.
  subscription_start: [
    'quiz_subscription_start',
    (d) => ({ product_id: itemId(d.handle), purchase_type: 'subscription', quiz_valor: pesos(d.valor) }),
  ],
  abandon: [
    'quiz_abandon',
    (d) => ({ step_number: d.paso, question_id: d.pregunta, quiz_respondidas: d.respondidas }),
  ],
};

Object.entries(EVENTOS).forEach(([dom, [nombre, campos]]) => {
  document.addEventListener(`quiz:${dom}`, (e) => {
    empujar(nombre, { quiz_id: e.detail.id, ...campos(e.detail) });
  });
});
